<div class="container-fluid">
    <mat-card>
      <mat-card-content>
        <div class="row">
          <div class="col-5">
              <span class="h6 text-muted align-middle"><strong>Dashboard</strong> - Enquadramento</span>
          </div>
          <div class="col-1 text-right align-middle" title="Quantidade total de registros" style="padding: 5px">
              <mat-progress-bar mode="indeterminate" *ngIf="loadingTotalRegras$ | async"></mat-progress-bar>
              <i class="fas fa-file-alt"></i>
              <span class="ml-2 h6 text-muted"><strong>{{ quantidadeTotalCarteiras$ | async }}</strong></span>
              Carteiras
          </div>
          <div class="col-1 text-left align-middle" title="Quantidade total de registros" style="padding: 5px">
              <mat-progress-bar mode="indeterminate" *ngIf="loadingTotalRegras$ | async"></mat-progress-bar>
              <i class="fas fa-tasks"></i>
              <span class="ml-2 h6 text-muted"><strong>{{ quantidadeTotalRegras$ | async }}</strong></span>
              Regras
          </div>
          <div class="col-5">
              <span class="h6 text-muted float-right mt-1 btn-refresh">
                  {{refreshDate | date: 'dd/MM/yyyy HH:mm:ss'}}<i (click)="emitterOnRefresh()" title="Atualizar dashboard"
                                                                  class="ml-3 font-weight-bold fas fa-sync"></i>
              </span>

          </div>
      </div>
      </mat-card-content>
    </mat-card>
</div>
